import React, { useState } from 'react';

function Reportcontent3({ onNext, onBack }) {
  const [formData, setFormData] = useState({
    abuseLocation: '',
    abuseDate: '',
    awarenessDate: '',
    randomOption: '',
    awarenessOption: '',
    personName: '',
    personFunction: '',
    personOrganization: '',
    abuseDescription: '',
  });
  const [selectedFiles, setSelectedFiles] = useState([]); 
  const [fileNames, setFileNames] = useState([]); 

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const selectFiles = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    setFileNames(files.map((file) => file.name));
  };

  const handleNextClick = async (e) => {
    e.preventDefault(); 

    if (!formData.abuseLocation || !formData.abuseDate || !formData.abuseDescription) {
      alert('Please fill in all required fields.');
      return;
    }

    const dataToSend = new FormData();
    
    Object.entries(formData).forEach(([key, value]) => {
      dataToSend.append(key, value);
    });


    selectedFiles.forEach(file => {
      dataToSend.append('files', file);
    });


    onNext({data: {...formData, selectedFiles}});
  };

  return (
    <div className='r-content'>
      <p className='content-text'>
        In order to successfully process your application, it is important that you provide as much information as possible about the case. The information that you must provide in your application is marked with an asterisk and you will not be able to continue the process without it. It is also desirable to provide other information, but you can skip it if you do not know it and continue with the application submission process.
      </p>
      <br />

      <form method='POST' className='report-fill-information' onSubmit={handleNextClick}> 
        <div className="fill-opt1">
          <p htmlFor="">Where did the violation take place?</p>
          <input
            type="text"
            name="abuseLocation"
            value={formData.abuseLocation}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="fill-opt1">
          <p>When did the violation happen?</p>
          <input
            type="date"
            name="abuseDate"
            value={formData.abuseDate}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="fill-opt1">
          <p>If you don’t know the exact date, just pick one of the given options.</p>
          <div className="custom-select">
            <select
              name="randomOption"
              value={formData.randomOption}
              onChange={handleInputChange}
              className="custom-dropdown"
            >
              <option value="0">Recently</option>
              <option value="1">In the last 3 month</option>
              <option value="2">In the last 6 month</option>
              <option value="3">In the last year</option>
              <option value="4">More than a year ago</option>
              <option value="4">I don't know</option>
            </select>
          </div>
        </div>

        <div className="fill-opt1">
          <p>When did you become aware of the abuse?</p>
          <input
            type="date"
            name="awarenessDate"
            value={formData.awarenessDate}
            onChange={handleInputChange}
          />
        </div>

        <div className="fill-opt1 gridoption2">
          <p>If you don’t know the exact date, just pick one of the given options.</p>
          <div className="custom-select">
            <select
              name="awarenessOption"
              value={formData.awarenessOption}
              onChange={handleInputChange}
              className="custom-dropdown"
            >
              <option value="0">Recently</option>
              <option value="1">In the last 3 month</option>
              <option value="2">In the last 6 month</option>
              <option value="3">In the last year</option>
              <option value="4">More than a year ago</option>
              <option value="4">I don't know</option>
            </select>
          </div>
        </div>

        <div className="content-text">Persons or violators who are charged with the report, or who are related to them:</div>
        <div className="threeinputs">
          <div className="fill-opt1">
            <p>Name and surname</p>
            <input
              type="text"
              name="personName"
              value={formData.personName}
              onChange={handleInputChange}
            />
          </div>
          <div className="fill-opt1">
            <p>Position</p>
            <input
              type="text"
              name="personFunction"
              value={formData.personFunction}
              onChange={handleInputChange}
            />
          </div>
          <div className="fill-opt1">
            <p>Organization or department</p>
            <input
              type="text"
              name="personOrganization"
              value={formData.personOrganization}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="fill-opt1 fill-textarea">
          <p>Description of the violation</p>
          <textarea
            name="abuseDescription"
            value={formData.abuseDescription}
            onChange={handleInputChange}
            rows={5}
            required
          ></textarea>
        </div>

        <div className="file-uploader">
          <input
            type="file"
            id="file-input"
            multiple
            onChange={selectFiles} 
            style={{ display: 'none' }}
          />
          <label htmlFor="file-input" className="custom-file-button">
            Attach Files
          </label>
          <p>{fileNames.length > 0 ? fileNames.join(', ') : ' '}</p>
        </div>
      </form>

      <div className="back-next">
        <button className="Backbtn" onClick={onBack}>Back</button>
        <button className="Nextbtn" type="submit" onClick={handleNextClick}>Next</button>
      </div>
    </div>
  );
}

export default Reportcontent3;
